import { useTranslation } from 'react-i18next';

import { message } from 'antd';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { handleAuth } from 'store/reducers/auth.reducer';

import { useMutation } from '@tanstack/react-query';
import { emailRegisterFinish } from 'api';
import { AppRoutes } from 'config/routes';
import { EmailStartRegisterRequest } from 'models/api/auth/email-register-auth-request';
import { useState } from 'react';

interface EmailRegisterProps {
  pinCode: string;
  password: string;
  token: string;
}

export default function useEmailRegister() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [isLoading, setLoading] = useState(false);

  const { mutateAsync: finishRegister } = useMutation((data: EmailStartRegisterRequest) =>
    emailRegisterFinish(data),
  );

  const register = async ({ pinCode, password, token }: EmailRegisterProps) => {
    try {
      setLoading(true);

      const result = await finishRegister({ pin_code: pinCode, password, data: {}, token });

      dispatch(handleAuth(result));
      navigate(AppRoutes.Dashboard.Home + AppRoutes.Dashboard.Contracts.Home);
    } catch (error: any) {
      message.error(error?.message || t('Something went wrong...'));
    } finally {
      setLoading(false);
    }
  };

  return { register, isLoading };
}
